import { AiOutlineCreditCard, AiOutlineShop } from "react-icons/ai";
import { SCREENS } from "navigation/consts";
import { useIntl } from "react-intl";
import { useVenueContext } from "contexts/VenueContext";
import { usePaymentTerminalContext } from "contexts/PaymentTerminalContext";
import SettingsGroup from "components/atoms/SettingsGroup";
import SettingsItem from "components/atoms/SettingsItem";
import { Link } from "@react-navigation/native";

const Settings: React.FC = () => {
  const intl = useIntl();
  const { venue } = useVenueContext();
  const { paymentTerminal } = usePaymentTerminalContext();

  return (
    <>
      <SettingsGroup label={intl.formatMessage({ defaultMessage: "General" })}>
        <Link to={{ screen: SCREENS.VenueSettings }}>
          <SettingsItem
            label={intl.formatMessage({ defaultMessage: "Venue" })}
            icon={AiOutlineShop}
            description={venue?.name}
          />
        </Link>
      </SettingsGroup>
      <SettingsGroup label={intl.formatMessage({ defaultMessage: "Payments" })}>
        <Link to={{ screen: SCREENS.TerminalSettings }}>
          <SettingsItem
            label={intl.formatMessage({ defaultMessage: "Terminal" })}
            icon={AiOutlineCreditCard}
            description={paymentTerminal?.name}
          />
        </Link>
      </SettingsGroup>
    </>
  );
};

export default Settings;
